// ####################################################
// BREAKPOINTS
// ####################################################

export const MOBILE_BREAKPOINT = 500;
export const TABLET_BREAKPOINT = 580;
export const DESKTOP_BREAKPOINT = 730;
export const CUSTOM_BREAKPOINT = 680;
export const DRAWER_WIDTH = 424;

// ####################################################
// Third-Party API's
// ####################################################

export const FLAG_CDN = 'https://flagcdn.com/w40/';
